import { Tag } from '../db/db';

import { groupBy, sortBy } from 'lodash';
import { Page, PageFilter, PageSortOrder } from '../db/pages';
import { FlagTag } from '../db/constants';

export enum TagSortOrder {
  name = 'name',
  recent = 'recent',
  // TODO: similarity = 'similarity', (not implemented)
}

export function pageToTagSortOrder(pageSortOrder: PageSortOrder): TagSortOrder {
  if (pageSortOrder === PageSortOrder.recent) {
    return TagSortOrder.recent;
  } else {
    return TagSortOrder.name;
  }
}

const tagSortOrderMap = {
  name: (tag: Tag) => tag.name,
  recent: (tag: Tag) => -(tag.last_active || 0),
};

export function sortTags(tags: Tag[] | undefined, sortOrder: TagSortOrder): Tag[] {
  return sortBy(tags, tagSortOrderMap[sortOrder]);
}

export const pageSortOrderMap = {
  title: (page: Page) => page.title,
  domainSortKey: (page: Page) => page.nurl.domainSortKey,
  lastActiveDesc: (page: Page) => page.lastActiveDesc,
  hotnessDesc: (page: Page) => page.hotnessDesc,
};

export function sortPages(pages: Page[] | undefined, sortOrder: PageSortOrder, similarUrls: { [key: string]: number }): Page[] {
  if(sortOrder === PageSortOrder.similarity) {
    return sortBy(pages, (page) => - (similarUrls[page.nurl.normalized] || 0));
  }
  return sortBy(pages, pageSortOrderMap[sortOrder]);
}

export function filterPage(page: Page, filter: PageFilter): boolean {
  return !(filter.flagged && !page.humanTags.includes(FlagTag));
}

export function filterPages(pages: Page[], filter: PageFilter): Page[] {
  return pages.filter((page) => {
    if (filter.flagged && !page.humanTags.includes(FlagTag)) {
      return false;
    }
    return true; // Assume pass
  });
}

export function groupPagesByWindow(pages: Page[]) {
  const windowGroups = groupBy(pages, 'lastWindowId');

  // Windows always sorted by recent, since nothing else makes sense.
  // Avoid spread operator (stack overflow risk on large page arrays).
  const windowGroupsSorted = sortBy(
    Object.entries(windowGroups),
    ([, pages]) => pages.reduce((min, p) => Math.min(min, p.lastActiveDesc), Infinity)
  );
  return windowGroupsSorted;
}
